(function($) {
  $(document).ready(function() {
    $(".two-grid-slider .slider-wrap")
      .not(".slick-initialized")
      .slick({
        draggable: true,
        arrows: true,
        dots: true,
        fade: true,
        speed: 900,
        dotsClass: "custom-dots",
        infinite: true,
        autoplay: false,
        nextArrow: $(".next-icon"),
        prevArrow: $(this)
          .parent()
          .find(".prev"),
        cssEase: "cubic-bezier(0.7, 0, 0.3, 1)"
      });
  });
})(jQuery);
